import { useState, useCallback, useEffect, useRef } from 'react';
import { getJuthoorAdminDashboard } from '@/lib/api/juthoor-admin';
import type { JuthoorAdminDashboard } from '@/types/juthoor';

export function useJuthoorAdminDashboard(): {
  data: JuthoorAdminDashboard | null;
  loading: boolean;
  error: string | null;
} {
  const [data, setData] = useState<JuthoorAdminDashboard | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const fetchDashboard = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getJuthoorAdminDashboard();
      if (!mountedRef.current) return;
      if (response.success && response.data) {
        setData(response.data);
      } else {
        setError(response.message || 'Failed to load admin dashboard');
      }
    } catch (err) {
      if (!mountedRef.current) return;
      setError(err instanceof Error ? err.message : 'Failed to load admin dashboard');
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return { data, loading, error };
}
